"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../../icon"));

var _index = _interopRequireDefault(require("./index.scss"));

var TabsHeader = function TabsHeader(_ref) {
  var headings = _ref.headings,
      _ref$icons = _ref.icons,
      icons = _ref$icons === void 0 ? [] : _ref$icons,
      selectedTab = _ref.selectedTab,
      onTabHeadingClick = _ref.onTabHeadingClick,
      fullWidth = _ref.fullWidth,
      disabledTabVal = _ref.disabledTabVal;
  return _react["default"].createElement("div", {
    className: fullWidth ? _index["default"].tabBarFull : _index["default"].tabBar
  }, _react["default"].createElement("ul", {
    id: "container",
    className: fullWidth ? _index["default"].tabHeaderFull : (0, _classnames["default"])(_index["default"].tabHeader),
    role: "tablist"
  }, headings.map(function (heading, i) {
    return _react["default"].createElement("li", {
      key: "tabHeading".concat(i),
      role: "presentation"
    }, Boolean(icons[i]) && _react["default"].createElement(_icon["default"], {
      className: (0, _classnames["default"])(_index["default"].tabIcon, (0, _defineProperty2["default"])({}, _index["default"].tabIconDisabled, disabledTabVal === heading)),
      type: icons[i]
    }), _react["default"].createElement("button", {
      className: (0, _classnames["default"])(fullWidth ? _index["default"].tabTitleFull : _index["default"].tabTitle, (0, _defineProperty2["default"])({}, _index["default"].activeTabTitle, selectedTab === i)),
      disabled: disabledTabVal === heading,
      "aria-controls": "tabpanel".concat(i),
      "aria-selected": selectedTab === i,
      role: "tab",
      index: i,
      onClick: onTabHeadingClick
    }, heading));
  })));
};

TabsHeader.propTypes = {
  selectedTab: _propTypes["default"].number,
  headings: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onTabHeadingClick: _propTypes["default"].func,
  fullWidth: _propTypes["default"].bool,
  disabledTabVal: _propTypes["default"].string,
  icons: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
TabsHeader.defaultProps = {
  fullWidth: false
};
var _default = TabsHeader;
exports["default"] = _default;